const chatMessage = {
  title: 'Click.AI',
  copyMessage: 'Texto copiado com sucesso!',
  copyError: 'Erro ao copiar o texto!',
  chatSessionError: 'Erro ao iniciar a sessão com o Click.AI.',
  helpPrompt: {
    title: 'Como posso te ajudar hoje?',
    firstSteps: 'Guia de primeiros passos',
    template: {
      whatIs: 'O que é um modelo?',
      howToCreate: 'Como criar um modelo?',
    },
    formFlow: {
      whatIs: 'O que é um fluxo com formulário?',
      howToCreate: 'Como criar um fluxo com formulário?',
    },
    pendingAnswers: {
      whatIs: 'O que são respostas pendentes?',
    },
    spreadsheetFlows: {
      whatIs: 'O que é um fluxo de planilha?',
      howToCreate: 'Como criar um fluxo de planilha?',
    },
    compliance: {
      whatIs: 'O que é a aprovação das respostas?',
    },
  },
  footer: {
    input: {
      placeholder: 'Fale com o Click.AI',
    },
    help: {
      text: 'Ainda tem dúvidas? Acesse nossa',
      link: 'Central de Ajuda',
    },
  },
};

export default chatMessage;
